import { makeQueryStringDync,makeQueryFormDataDyn, errorServeiceHandler } from '../../helper'
const state = {
}
const getters = {
}
const mutations = {
}
const actions = {
    getRenewPacks: (context, filterData) => {
    console.log("got response in report module",filterData)
    return new Promise( (resolve, reject) => {

      //Remove Multiple call code
      // let getRenewSearch = JSON.parse(localStorage.getItem('getRenewSearch'))
      // let lastCustomerSearch = JSON.parse(localStorage.getItem('lastRenewCustomerSearch'))
      // if (getRenewSearch && lastCustomerSearch) {
      //   if (Object.keys(getRenewSearch).length && lastCustomerSearch == filterData.subscriberid) {
      //     resolve(getRenewSearch)
      //     return
      //   }
      // }
      //Remove Multiple call code End
      
    let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
           
      fetch(context.getters.baseUrl + '/lco/v1/plan/subscriber' + queryStr, {
        method: 'GET'
        })
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json()
          }).then((data) => {
            localStorage.setItem("getRenewSearch",JSON.stringify(data))
            localStorage.setItem("lastRenewCustomerSearch",JSON.stringify(filterData.subscriberid))
            resolve(data)
          }).catch((error) => {
            reject(error);
          });
        });
    },
    getRenewChannel: (context, filterData) => {
    return new Promise( (resolve, reject) => {           
      fetch(context.getters.baseUrl + '/lco/v1/plan/scheduleautorenew' + filterData, {
        method: 'GET'
        })
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json()
          }).then((data) => {
              resolve(data)
          }).catch((error) => {   
            reject(error)
          });
        });
    },
    getAutoRenewPacks: (context, filterData) => {
      console.log("got response in report module",filterData)
      return new Promise( (resolve, reject) => {

      //Remove Multiple call code
      // let getAutoRenewSearch = JSON.parse(localStorage.getItem('getAutoRenewSearch'))
      // let lastCustomerSearch = JSON.parse(localStorage.getItem('lastAutoRenewCustomerSearch'))
      // if (getAutoRenewSearch && lastCustomerSearch) {
      //   if (Object.keys(getAutoRenewSearch).length && lastCustomerSearch == filterData.subscriberid) {
      //     resolve(getAutoRenewSearch)
      //     return
      //   }
      // }
      //Remove Multiple call code End

      let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
             
        fetch(context.getters.baseUrl + '/lco/v1/plan/scheduleautorenew' + queryStr, {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
              return response.json()
            }).then((data) => {
              localStorage.setItem("getAutoRenewSearch",JSON.stringify(data))
              localStorage.setItem("lastAutoRenewCustomerSearch",JSON.stringify(filterData.subscriberid))
              resolve(data)
            }).catch((error) => {
              reject(error);
            });
          });
      },
      activateAutoRenew: (context,formdata) => {
        return new Promise( (resolve, reject) => {
            localStorage.removeItem("getAutoRenewSearch")
            localStorage.removeItem("lastAutoRenewCustomerSearch")
            
            if (!formdata) {
                reject({error: "formdata not found"});
            }
            let data = makeQueryFormDataDyn(formdata);
           fetch(context.getters.baseUrl + '/lco/v1/plan/actiavteplan', {
            method: 'POST',
            body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
              return response.json()
           }).then((data) => {
             
                resolve(data)
              
            }).catch((error) => {
                reject(error);
            });
        });
    },
    deactivateAutoRenew: (context,formdata) => {
      return new Promise( (resolve, reject) => {
          localStorage.removeItem("getAutoRenewSearch")
          localStorage.removeItem("lastAutoRenewCustomerSearch")

          if (!formdata) {
              reject({error: "formdata not found"});
          }
          let data = makeQueryFormDataDyn(formdata);
         fetch(context.getters.baseUrl + '/lco/v1/plan/deactiavteplan', {
          method: 'POST',
          body: data
         })
         .then(errorServeiceHandler)
         .then((response) => {
            return response.json()
         }).then((data) => {
            
              resolve(data)
            
          }).catch((error) => {
              reject(error);
          });
      });
    },
    changeValidity: (context,formdata) => {
      return new Promise( (resolve, reject) => {
        localStorage.removeItem("getAutoRenewSearch")
        localStorage.removeItem("lastAutoRenewCustomerSearch")

          if (!formdata) {
              reject({error: "formdata not found"});
          }
          let data = makeQueryFormDataDyn(formdata);
         fetch(context.getters.baseUrl + '/lco/v1/plan/changevalidity', {
          method: 'POST',
          body: data
         })
         .then(errorServeiceHandler)
         .then((response) => {
            return response.json()
         }).then((data) => {
            
              resolve(data)
            
              
          }).catch((error) => {
              reject(error);
          });
      });
    },
    autoSchedule: (context,formdata) => {
      return new Promise( (resolve, reject) => {
        localStorage.removeItem("getAutoRenewSearch")
        localStorage.removeItem("lastAutoRenewCustomerSearch")
        
          if (!formdata) {
              reject({error: "formdata not found"});
          }
          let data = makeQueryFormDataDyn(formdata);
         fetch(context.getters.baseUrl + '/lco/v1/plan.php/schedule', {
          method: 'POST',
          body: data
         })
         .then(errorServeiceHandler)
         .then((response) => {
            return response.text()
         }).then((data) => {
           
              resolve(data)
            
          }).catch((error) => {
              reject(error);
          });
      });
    }
};

export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/productModule/renewModule.js